// extracted by mini-css-extract-plugin
module.exports = {"buttons":"mfa-settings__buttons","registerButton":"mfa-settings__registerButton"};